export const LiveChatHideAutomationKey = 'hideAutomation'
